<li class="note-content-card {{#has_image}}with-image{{/has_image}}{{^has_image}} {{/has_image}}">
  <div  class="avatar">
    <a href="/{{user.slug}}">
      {{#uses_gravatar}}
        <img class="user-image" aria-hidden="true" src="{{gravatar_url}}" />
      {{/uses_gravatar}}
      {{^uses_gravatar}}
        <div class="user-image {{avatar}}-avatar" style="background-color: {{color}}">
        </div>
      {{/uses_gravatar}}
    </a>
  </div>

  <div class="details" aria-hidden="true">
    <div class="content">
      <div class="author">
        By
        <a href="/{{user.slug}}">
          {{user.username}}
        </a>
      </div>

      <a href="/{{slug}}" class="title-link">
        {{title}}
      </a>

      {{#description}}
        <div class="description text-element">
          {{{description}}}
        </div>
      {{/description}}
    </div>
  </div>

  {{#has_image}}
    <div class="image">
      <div class="element">
        {{#is_url_image}}
          <img class="image-url img-responsive" src="{{image_url}}" />
        {{/is_url_image}}

        {{^is_url_image}}
          {{#image_animated}}

            <video class="video-preview" preload="auto" muted="muted" loop="loop"
              playsinline poster="{{image_standard}}">
              <source src="{{image_mp4}}">
              Your browser does not support the video tag.
            </video>
          {{/image_animated}}
          {{^image_animated}}
            <img src="{{image_standard}}" class="image-preview" alt="{{title}}">
          {{/image_animated}}
        {{/is_url_image}}
      </div>
    </div>
  {{/has_image}}
  <div class="options-bar">
    <div class="user-page-badges">
      {{#featured}}
        <div class="user-page-badge loved-by-adafruit">
        </div>
      {{/featured}}

      {{#seen_on_show_and_tell}}
        <div class="user-page-badge show-and-tell">
        </div>
      {{/seen_on_show_and_tell}}

      {{#made_with_circuitpython}}
        <div class="user-page-badge made-with-circuit-python">
        </div>
      {{/made_with_circuitpython}}
    </div>
  </div>
</li>
